import { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { X } from 'lucide-react';
import { CompanyStatusTable } from '../../pages/admin/fund-details/CompanyStatusTable';
import { SubmissionDetailDrawer } from '../SubmissionDetailDrawer';
import { EmailTimelineDrawer } from '../EmailTimelineDrawer';
import type { FundSubmissionStatus } from '@lingaai/supabase-client';

interface SubmissionStatusPanelProps {
  fundName: string;
  period: string;
  submissions: FundSubmissionStatus[];
  onClose: () => void;
}

export function SubmissionStatusPanel({ fundName, period, submissions, onClose }: SubmissionStatusPanelProps) {
  const [selectedSubmissionId, setSelectedSubmissionId] = useState<string | null>(null);
  const [timelineSubmissionId, setTimelineSubmissionId] = useState<string | null>(null);

  // Check if this is a multi-fund view
  const isMultiFund = submissions.length > 0 && submissions[0] && 'fund_name' in submissions[0];
  const displayTitle = isMultiFund ? 'All Funds' : fundName;

  const handleSendReminder = async (companyId: string) => {
    // TODO: Implement reminder functionality
    console.log('Sending reminder to company:', companyId);
  };

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Box>
          <Typography variant="h6">{displayTitle}</Typography>
          <Typography variant="body2" color="text.secondary">
            {period}
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small">
          <X size={20} strokeWidth={1} />
        </IconButton>
      </Box>

      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <CompanyStatusTable submissions={submissions} onViewSubmission={setSelectedSubmissionId} onViewTimeline={setTimelineSubmissionId} onSendReminder={handleSendReminder} />
      </Box>

      <SubmissionDetailDrawer submissionId={selectedSubmissionId} open={!!selectedSubmissionId} onClose={() => setSelectedSubmissionId(null)} />

      <EmailTimelineDrawer submissionId={timelineSubmissionId} open={!!timelineSubmissionId} onClose={() => setTimelineSubmissionId(null)} />
    </Box>
  );
}
